import { genericFormatter } from './genericFormatter';

export const generateAssetTitle = (title?: string, postalCode?: string): string => {
  if (title && postalCode) return genericFormatter([title, postalCode], ' • ');
  if (!title && !postalCode) return '';
  if (!postalCode) return title ?? '';
  if (!title) return postalCode ?? '';
  return '';
};
